import { UUIDTypes } from 'uuid'

export enum SpeciConsignmentStatus {
  ConsignmentComplete = 'CONSIGNMENT_COMPLETE',
  ConsignmentNotCompleteHoldForBalance = 'CONSIGNMENT_NOT_COMPLETE_HOLD_FOR_BALANCE',
  ShearingNotCompleteSellQualifiedWool = 'SHEARING_NOT_COMPLETE_SELL_QUALIFIED_WOOL',
}

export enum SpeciType {
  Grower = 'GROWER',
  Hub = 'HUB',
}

// Type is used to represent a line in the Speci data.
export type SpeciLine = {
  baleNumbers: number[]
  description: string
  id: UUIDTypes
  instructions?: string | null
  number?: string | null
  traditionalDescription?: string | null
  originalInstructions?: string | null
}

// Type is used to represent the data for a Speci.
export type SpeciData = {
  id: UUIDTypes
  type?: SpeciType | null
  lines: SpeciLine[]
  breeds: string[]
  classer?: string | null
  classerComment?: string | null
  consignmentStatus?: SpeciConsignmentStatus | null
  woolStore?: string | null
  stationAreaManagerEmail?: string | null
  stationAreaManagerFullName?: string | null
  sentToWoolStoreAt?: string | null
  sentToWoolStoreBy?: string | null
}

// Type is used to represent a map of SpeciLine objects.
export type SpeciLinesMap = {
  [key: string]: SpeciLine
}

// Modified version of SpeciData where the lines are stored in a map.
export type SpeciDataLinesMap = Omit<SpeciData, 'lines'> & {
  lines: SpeciLinesMap
}

/* STATION RELATED */

// Station details for a speci
export type SpeciStation = {
  recordNumber: string
  brand?: string | null
  tradingName?: string | null
}

// Contract detail for a speci
export type SpeciContractDetail = {
  recordNumber: string
  contractName?: string | null
}

// Additional station details for a speci
export type SpeciStationDetails = {
  currentSeasonContracts: SpeciContractDetail[]
  rwsStatus?: string | undefined | null
  zqStatus?: string | undefined | null
  zqrxStatus?: string | undefined | null
  isRws?: boolean
}
